// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// Tooltip from react-bootstrap not used for data-tooltip attributes
// import { Tooltip } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./Assets/css/common.css";
import "./App.css";
import { jwtDecode } from "jwt-decode";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "leaflet/dist/leaflet.css";
import Loader from "./components/Loader";
import Authmiddleware from "./routes/Authmiddleware";
import AdminAuthmiddleware from "./routes/AdminAuthmiddleware";
import { LoaderProvider } from "./context/LoaderContext";
import "react-tooltip/dist/react-tooltip.css";

// Lazy-loaded routes for optimal bundle size and initial load speed
const Login = React.lazy(() => import("./components/Login"));
const Signup = React.lazy(() => import("./components/Signup"));
const ForgotPassword = React.lazy(() => import("./components/ForgotPassword"));
const ResetPassword = React.lazy(() => import("./components/ResetPassword"));
const UserList = React.lazy(() => import("./components/Admin/UserList"));
const Dashboard = React.lazy(() => import("./components/Dashboard/Dashboard"));
const TermsCondition = React.lazy(() => import("./components/TermsCondition"));
const PaymentSuccess = React.lazy(() => import("./components/PaymentSuccess"));
const AdminDashboard = React.lazy(() => import("./components/Admin/Dashboard"));
const PublicPage = React.lazy(() => import("./components/PublicPage/PublicPage"));
const CustomProfile = React.lazy(() => import("./components/CustomProfile/CustomProfile"));
const Home = React.lazy(() => import("./components/Home/Home"));
const News = React.lazy(() => import("./components/News/News"));
const AllFeatures = React.lazy(() => import("./components/AllFeatures/AllFeatures"));
const CensorCompliance = React.lazy(() => import("./components/CensorCompliance/CensorCompliance"));
const ReferralCodes = React.lazy(() => import("./components/Admin/ReferralCodes"));
const ResourceTablePage = React.lazy(() => import("./components/ResourceTable/ResourceTablePage"));

const PageFallbackLoader = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f8fafc",
    }}
  >
    <div
      className="spinner-border text-primary"
      role="status"
      style={{ width: "2.5rem", height: "2.5rem" }}
    >
      <span className="visually-hidden">Loading page...</span>
    </div>
  </div>
);

const GOOGLE_CLIENT_ID = "655676158730-du47rruo2opgjhjve2s77tvh9e62onvd.apps.googleusercontent.com";

const authProtectedRoutes = [
  {
    path: "/user/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/user/customprofile",
    component: <CustomProfile />,
  },
  {
    path: "/user/resource-table",
    component: <ResourceTablePage />,
  },
  {
    path: "/user/resource-table/:tab",
    component: <ResourceTablePage />,
  },
];

const adminAuthProtectedRoutes = [
  {
    path: "/admin/dashboard",
    component: <AdminDashboard />,
  },
  {
    path: "/admin/user",
    component: <UserList />,
  },
  {
    path: "/admin/referral-codes",
    component: <ReferralCodes />,
  },
];

function App() {
  const token = localStorage.getItem("token");
  let decoded = null;

  try {
    if (token) {
      decoded = jwtDecode(token);
    }
  } catch (err) {
    console.error("Invalid token:", err);
    decoded = null;
  }

  useEffect(() => {
    const pageFont =
      window.localStorage.getItem("biome_page_font") || null;
    if (pageFont) {
      document.documentElement.style.setProperty("--page-font", pageFont);
    }
  }, []);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <LoaderProvider>
        <Router>
          <Loader />
          <React.Suspense fallback={<PageFallbackLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/page/allfeatures" element={<AllFeatures />} />
              <Route path="/page/censorcompliance" element={<CensorCompliance />} />
              <Route path="/page/news" element={<News />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/signup" element={<Signup />} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route path="/biome/terms-condition" element={<TermsCondition />} />
              <Route path="/biome/payment-success" element={<PaymentSuccess />} />
              <Route path="/:userName" element={<PublicPage />} />

              {authProtectedRoutes?.map((route, idx) => (
                <Route
                  key={idx}
                  path={route.path}
                  element={<Authmiddleware>{route.component}</Authmiddleware>}
                />
              ))}
              {adminAuthProtectedRoutes?.map((route, idx) => (
                <Route
                  key={idx}
                  path={route.path}
                  element={
                    <AdminAuthmiddleware>{route.component}</AdminAuthmiddleware>
                  }
                />
              ))}
            </Routes>
          </React.Suspense>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
      </Router>
      {/* react-tooltip root element for data-tooltip-* attributes */}
      <ReactTooltip
        id="my-tooltip"
        place="left"
        effect="solid"
        backgroundColor="#333"
        textColor="#fff"
        className="custom-tooltip"
      />
      </LoaderProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
